import React, { useState, useEffect } from "react";
import { TextField, Box, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setProfileState } from "../../../actions/MyTechProfile/myTechProfileActions"; // Adjust the import path as needed
import "./EditContactDetails.css";

const EditContactDetails = () => {
  const dispatch = useDispatch();

  // Select the profile from the Redux store
  const { profile } = useSelector((state) => state.editMyTechProfileStore);

  // Local state for each input field
  const [title, setTitle] = useState("");
  const [availabilityTitle, setAvailabilityTitle] = useState("");
  const [availabilitySubtitle, setAvailabilitySubtitle] = useState("");
  const [footerLine, setFooterLine] = useState("");

  // Populate local state from Redux store when the component mounts or profile data changes
  useEffect(() => {
    if (profile && profile.contactDetails) {
      setTitle(profile.contactDetails.title || "");
      setAvailabilityTitle(profile.contactDetails.availabilityTitle || "");
      setAvailabilitySubtitle(
        profile.contactDetails.availabilitySubtitle || ""
      );
      setFooterLine(profile.contactDetails.footerLine || "");
    }
  }, [profile]);

  // Handles input changes, updates local state, and dispatches an action to update Redux
  const handleChange = (field, value) => {
    // Update local state to ensure the input field reflects changes immediately
    switch (field) {
      case "title":
        setTitle(value);
        break;
      case "availabilityTitle":
        setAvailabilityTitle(value);
        break;
      case "availabilitySubtitle":
        setAvailabilitySubtitle(value);
        break;
      case "footerLine":
        setFooterLine(value);
        break;
      default:
        break;
    }

    // Prepare the updated contact details object
    const updatedContactDetails = { ...profile.contactDetails, [field]: value };

    // Dispatch the action to update the entire profile in the Redux store
    dispatch(
      setProfileState({ ...profile, contactDetails: updatedContactDetails })
    );
  };

  return (
    <Box>
      {/* Title Field */}
      <Typography variant="subtitle1" className="edit-contact-details-label">
        Edit Title
      </Typography>
      <TextField
        fullWidth
        variant="outlined"
        size="small"
        value={title}
        onChange={(e) => handleChange("title", e.target.value)}
        sx={{ marginBottom: "20px" }}
      />

      {/* Availability Title Field */}
      <Typography variant="subtitle1" className="edit-contact-details-label">
        Edit Availability Title
      </Typography>
      <TextField
        fullWidth
        variant="outlined"
        size="small"
        value={availabilityTitle}
        onChange={(e) => handleChange("availabilityTitle", e.target.value)}
        sx={{ marginBottom: "20px" }}
      />

      {/* Availability Subtitle Field */}
      <Typography variant="subtitle1" className="edit-contact-details-label">
        Edit Availability Subtitle
      </Typography>
      <TextField
        fullWidth
        multiline
        rows={3}
        variant="outlined"
        size="small"
        value={availabilitySubtitle}
        onChange={(e) => handleChange("availabilitySubtitle", e.target.value)}
        sx={{ marginBottom: "20px" }}
      />

      {/* Footer Line Field */}
      <Typography variant="subtitle1" className="edit-contact-details-label">
        Edit Footer Line
      </Typography>
      <TextField
        fullWidth
        variant="outlined"
        size="small"
        value={footerLine}
        onChange={(e) => handleChange("footerLine", e.target.value)}
        sx={{ marginBottom: "20px" }}
      />
    </Box>
  );
};

export default EditContactDetails;
